import {IPrescriptionTemplate} from 'core/api/prescription'
import {PrescriptionTemplatesByKey} from 'core/prescription'
import {filter} from 'lodash'
import {IState} from './'
import {IState as IInstitutionState} from './institution'

export const selectInstitution =
  ({studyCoordinator}: {studyCoordinator: IState}): IInstitutionState => studyCoordinator.institution

export const selectAllowedPrescriptionTemplates =
  ({studyCoordinator}: {studyCoordinator: IState}): IPrescriptionTemplate[] => {
    const institution = selectInstitution({studyCoordinator})
    if (!institution) return []
    const allowed = new RegExp(institution.allowedPrescriptionTemplates, 'i')
    return filter(PrescriptionTemplatesByKey, (template, key: string) => key.match(allowed))
  }

export const selectSubjectDefaultPrescriptionTemplate =
  ({studyCoordinator}: {studyCoordinator: IState}, subjectIdentifier: string): IPrescriptionTemplate | undefined => {
    const institution = selectInstitution({studyCoordinator})
    if (!institution) return undefined
    const key = 'CAM2_CONST_CONTRAST'
    return PrescriptionTemplatesByKey[key]
    // const defaultPrescriptionTemplateKey = institution.subjectToPrescriptionTemplate[subjectIdentifier]
    // if (!defaultPrescriptionTemplateKey) return undefined
  }



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/study-coordinator/selectors.ts